import { Link } from "react-router-dom";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import Rankings from "./Rankings";
import RankingsEditor from "./RankingsEditor";


const RankingFilter = () => {

  function clickinner(target) { // Target refers to the clicked element
    window.location.href=target;
};
  return (
    <div className="mb-2">
      <Dropdown as={ButtonGroup} size="lg">
        <Button>
  Filter By:
        </Button>
        <Dropdown.Toggle
          split
          id="dropdown-split-basic"
        />
        <Dropdown.Menu>
          <Dropdown.Item eventKey="1" onClick={() => clickinner('Ranking-By-Editor')}>
           Editor Rank
          </Dropdown.Item>
          <Dropdown.Item eventKey="2" onClick={() => clickinner('Ranking-By-Community')}>
            Community Rank
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default RankingFilter;